import { useSelector } from 'react-redux'
import { RootState } from '../redux/reducers/root'
import { Security } from '../redux/reducers/securities'

export const useInstrumentFilters = () => {
  const instruments: Security[] = useSelector((state: RootState) => state.securities.securities)
  const filters = useSelector((state: RootState) => state.filters)

  const matchInstrument = (instrument: Security): boolean => {
    if (filters.searchedMarketName && instrument.market !== filters.searchedMarketName) return false
    if (filters.searchedInstrumentIsin && !instrument.isin?.toLowerCase().includes(filters.searchedInstrumentIsin.toLowerCase())) return false
    if (filters.searchedInstrumentAssetClass && (instrument.assetClass ?? '') !== filters.searchedInstrumentAssetClass) return false
    if (filters.searchedInstrumentCurrency && instrument.currency !== filters.searchedInstrumentCurrency) return false
    if (filters.searchedInstrumentTicker && !instrument.ticker?.toLowerCase().includes(filters.searchedInstrumentTicker.toLowerCase())) return false
    if (filters.searchedInstrumentCategory && (instrument.category ?? '') !== filters.searchedInstrumentCategory) return false
    if (filters.searchedInstrumentExperience && (instrument.skillAndExperience ?? '') !== filters.searchedInstrumentExperience) return false
    if (filters.searchedInstrumentPreference && (instrument.preference ?? '') !== filters.searchedInstrumentPreference) return false
    if (filters.searchedInstrumentLossAbility && (instrument.lossAbility ?? '') !== filters.searchedInstrumentLossAbility) return false
    if (filters.searchedInstrumentRisk && String(instrument.riskValue ?? '') !== filters.searchedInstrumentRisk) return false
    if (filters.searchedInstrumentHorizonte && String(instrument.horizonteValue ?? '') !== filters.searchedInstrumentHorizonte) return false
    return true
  }

  return Array.isArray(instruments) ? instruments.filter(matchInstrument) : []
}
